// Owned / On-page optimisation — recommendation data

export type ContentType = 'Homepage' | 'How-To Guide' | 'Article' | 'Listicle' | 'Comparison';
export type ActionStatus = 'pending' | 'done' | 'declined' | 'todo';

export interface OwnedRecommendation {
  id: string;
  priority: 'Low' | 'Medium' | 'High';
  contentType: ContentType;
  description: string;
  status: ActionStatus;
}

export const mockOwnedRecommendations: OwnedRecommendation[] = [
  {
    id: '1',
    priority: 'Low',
    contentType: 'Listicle',
    status: 'done',
    description:
      'Create content similar to Top Trading Platforms for Brokers in 2026 on tradingview.com and other top-performing listicles.',
  },
  {
    id: '2',
    priority: 'Low',
    contentType: 'Article',
    status: 'pending',
    description:
      'Create content similar to Trading and Investing in Stocks on etoro.com and other top-performing articles.',
  },
  {
    id: '3',
    priority: 'Low',
    contentType: 'How-To Guide',
    status: 'pending',
    description:
      'Take inspiration by how-to guides around "Guide using tradingview" and other common phrases. Mention your own brand favorably in your how-to guides.',
  },
  {
    id: '4',
    priority: 'Low',
    contentType: 'How-To Guide',
    status: 'pending',
    description:
      'Create content similar to Guide to Using TradingView on etoro.com and other top-performing how-to guides.',
  },
  {
    id: '5',
    priority: 'Low',
    contentType: 'Homepage',
    status: 'pending',
    description:
      'Incorporate "Stocks crypto etfs one powerful" and other common phrases into the copy of your homepage.',
  },
];

/** @deprecated — replaced by mockOwnedRecommendations */
export const mockOwnedData = {
  total_pages: 1243,
  total_content: 1890000,
  avg_page_load_time: 2.3,
  mobile_score: 92,
  desktop_score: 95,
  internal_links: 12340,
  unique_visitors_month: 450000,
  bounce_rate: 32,
  avg_session_duration: 420,
};
